export const isExerciseType = (type: string): boolean => {
  const normalizedType = type.toLowerCase().trim();
  return normalizedType === 'exercise';
};
